// 단체 통화 신호 보내기 — 상대 우편함(user-signal-<상대 id>)에 httpSend로 바로 보낸다
// 구독(subscribe)·해제(removeChannel)는 하지 않는다: 1:1 엔진과 같은 통로 객체를 나눠 쓸 수 있기 때문
// 3-2 2호: 이 함수를 부르는 곳은 아직 없음 → 동작 변화 0
import { supabase } from '../supabaseClient';

const GROUP_SEND_TIMEOUT_MS = 3000;
const GROUP_RETRY_TYPES = new Set(['ring', 'ring_cancel', 'leave']);

async function sendOnce({ fromUserId, toUserId, callId, type, data = {} }) {
  const channel = supabase.channel(`user-signal-${toUserId}`, { config: { private: true } });
  const payload = {
    type,
    call_id: callId,
    sender_id: fromUserId,
    target_user_id: toUserId,
    data,
  };
  try {
    const res = await channel.httpSend('group:signal', payload, { timeout: GROUP_SEND_TIMEOUT_MS });
    return res?.success ? 'ok' : 'error';
  } catch (err) {
    console.warn('[단체 신호] 보내기 실패 — 종류: ' + type + ', 사유: ' + (err?.message || err));
    return 'error';
  }
}

export async function sendGroupSignal({ fromUserId, toUserId, callId, type, data = {} }) {
  if (!fromUserId || !toUserId || !callId || !type) return 'error';
  if (fromUserId === toUserId) return 'error';
  const first = await sendOnce({ fromUserId, toUserId, callId, type, data });
  if (first === 'ok' || !GROUP_RETRY_TYPES.has(type)) return first;
  await new Promise((r) => setTimeout(r, 150));
  const second = await sendOnce({ fromUserId, toUserId, callId, type, data });
  console.warn(`[단체 신호] 1회 재전송 — 종류: ${type}, 결과: ${second}`);
  return second;
}
